// @flow

import throttle from 'lodash/throttle'

import { getPolopolyImageElement } from '../utils/imageUtils'
import { getOverlayElement } from '../utils/renderUtils'
import { constrain } from '../utils/general'

import { background, uncroppedImageContainer } from '../stylesheets/background.css'
import { alignCenter, alignMiddle } from '../stylesheets/alignment/index.css'

type flipScrollHandlerTypeProps = {
  alignment: ?Array<string>,
  polopolyIds: Array<string>,
  overlay: ?Boolean | Object,
  uncropped: ?Boolean,
  flipFade: ?Boolean
}

let eventListener = null
export const flipScrollComponent = {
  type: 'flip-scroll',
  render(
    id: string,
    props: flipScrollHandlerTypeProps,
    bgInnerHTML: ?string = ''
  ): string {
    const { alignment, polopolyIds, overlay, uncropped, flipFade = false } = props
    const alignmentClasses = alignment ?
      alignment.join(' ') :
      [alignMiddle, alignCenter].join(' ')

    let imageStyle = uncropped ?
      'position: absolute' :
      'min-width: 100%; min-height: 100%; position: absolute;'

    const imageElements = polopolyIds.map(polopolyId =>
      getPolopolyImageElement(
        polopolyId,
        alignmentClasses,
        imageStyle,
        flipFade ? 'transition: .5s opacity ease-in-out' : ''
      )
    )

    return `
      <div id="${id}" class="${background}">
        ${uncropped ? `<div class="${uncroppedImageContainer}">` : ''}
          ${imageElements.join('')}
        ${uncropped ? '</div>' : ''}
        ${bgInnerHTML}
        ${getOverlayElement(overlay)}
      </div>
    `
  },
  onCurrentChanged(currentSection) {
    if (eventListener) {
      document.removeEventListener('scroll', eventListener)
      eventListener = null
    }

    const { type } = currentSection
    if (type === 'flip-scroll') {
      eventListener = throttle(() => handleFlipScroll(currentSection), 30)
      document.addEventListener('scroll', eventListener, {
        passive: true
      })
    }
  }
}

export const handleFlipScroll = element => {
  const { y, top } = element.foregroundElement.getBoundingClientRect()

  const { innerHeight } = window
  const imageElements = element.backgroundElement.getElementsByTagName('picture')
  const numberOfImages = imageElements.length

  const pxInView = innerHeight - (y || top)
  const percentInView = constrain(pxInView / innerHeight, 0, 0.99)
  const idx = Math.floor(percentInView * numberOfImages)

  for (let i = 0; i < numberOfImages; i++) {
    imageElements[i].style.opacity = i === idx ? '1' : '0'
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/flipScroll.js